import Breadcrumbs from "@design-system/Breadcrumbs/Breadcrumbs";
import { Header } from "@design-system/Header/Header";

export const GettingStartedHeader = () => {
  return (
    <Header>
      <Header.Slot>
        <Breadcrumbs />
      </Header.Slot>
    </Header>
  );
};
